import session from 'services/sessionStorage'

const CF_RETURN_TO_PAGE_KEY = 'cf_return_to_page_location'

function useReturnToPage() {
  return {
    saveLocationToReturnTo: (value: string) => {
      if (!value.match(/redirect/i)) {
        session.setItem(CF_RETURN_TO_PAGE_KEY, value)
      }
    },
    getLocationToReturnTo: () => {
      const result = session.getItem(CF_RETURN_TO_PAGE_KEY)
      session.removeItem(CF_RETURN_TO_PAGE_KEY)
      return result ?? '/'
    },
  }
}

export default useReturnToPage
